// actions.ts
import {
    MM_RFQ_FORM_DATA,
    RESET_MM_RFQ_FORM_DATA,
    UPDATE_MM_RFQ_FORM_ITEM,
    UPDATE_SELECTED_VENDORS
} from "./actionTypes";

// Action creator for setting form data
export const setMmRfqFormData = (data: any[]) => ({
    type: MM_RFQ_FORM_DATA,
    payload: data
});

// Action creator for resetting form data
export const resetMmRfqFormData = () => ({
    type: RESET_MM_RFQ_FORM_DATA
});

// Action creator for updating a specific item in the form data
export const updateMmRfqFormItem = (data: any) => ({
    type: UPDATE_MM_RFQ_FORM_ITEM,
    payload: data
});
